module.exports = __webpack_public_path__ + "img/img_demand_01.87d63353.png";